import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { toolUserParamsCreate, toolUserParamsDelete, toolUserParamsList, toolUserParamsUpdate } from '@/api/toolUserParams';
import { AppError } from '@/errors/appError';
import { isRequestCanceled } from '@/services/baseService';
import { IToolUserParamsApiListResponse, IToolUserParamUpdateParams, IToolUserParamUpdateResponse } from '@/types/toolUserParams';

export const toolUserParamsService = {
    async listByToolUserId(toolUserId: number, config?: AxiosRequestConfig): Promise<AxiosResponse<IToolUserParamsApiListResponse>> {
        try {
            return await toolUserParamsList(toolUserId, config);
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('Tool user params API Error:', e);
            throw new AppError('Unable to load tool user params, request error', { cause: e });
        }
    },

    async create(params: IToolUserParamUpdateParams): Promise<AxiosResponse<IToolUserParamUpdateResponse>> {
        try {
            return await toolUserParamsCreate(params);
        } catch (e) {
            console.error('Tool user params create API Error:', e);
            throw new AppError('Unable to create tool user param, request error', { cause: e });
        }
    },

    async update(params: IToolUserParamUpdateParams): Promise<AxiosResponse<IToolUserParamUpdateResponse>> {
        try {
            return await toolUserParamsUpdate(params);
        } catch (e) {
            console.error('Tool user params update API Error:', e);
            throw new AppError('Unable to update tool user param, request error', { cause: e });
        }
    },

    async delete(params: IToolUserParamUpdateParams): Promise<AxiosResponse<IToolUserParamUpdateResponse>> {
        try {
            return await toolUserParamsDelete(params);
        } catch (e) {
            console.error('Tool user params delete API Error:', e);
            throw new AppError('Unable to delete tool user param, request error', { cause: e });
        }
    },
};
